import Vue from "vue";

export default {
  SET_MODULES(state, payload) {
    state.modulesList = payload;
  },
};
